import React from "react";
import css from "./FurnitureCard.module.css";
import { Furniture } from "@/state/Furniture";
import { Button } from "@/dom/components/Button/Button";
import { Column } from "@/dom/components/Panel/Column";
import { Typography } from "@/dom/components/Typography/Typography";

import infoSquareSvg from "public/assets/svg/info-square.svg";
import { formatPrice } from "@/utils/string";
import { formatDimensions } from "@/utils/dimensions";
import { useFurnitureManagementState } from "@/state/furnitureManagementState";

type FurnitureCardProps = {
    furniture: Furniture;
    onAdd: () => void;
    onSelect: () => void;
};

export const FurnitureCard: React.FC<FurnitureCardProps> = ({ furniture, onAdd, onSelect }) => {
    const { loadingFurnitureIds } = useFurnitureManagementState();
    const isLoading = loadingFurnitureIds.includes(furniture.id);

    return (
        <div className={css.main}>
            <div className={css.imageContainer}>
                <img src={furniture.resources.previewPath} alt={furniture.data.name} />
                <Button variant="icon" size="small" onClick={onSelect} className={css.infoButton}>
                    <img src={infoSquareSvg} alt="info" />
                </Button>
            </div>
            <div className={css.contentContainer}>
                <Column>
                    <Typography variant="body" weight="semibold">
                        {furniture.data.name}
                    </Typography>
                    <Typography variant="label" color="gray1">
                        {formatDimensions(furniture.data.dimensions)}
                    </Typography>
                    <Typography variant="body">{formatPrice(furniture.data.price)}</Typography>
                </Column>
                <Button onClick={onAdd} isLoading={isLoading} disabled={isLoading}>
                    Добавить
                </Button>
            </div>
        </div>
    );
};
